import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import NoData from '@src/features/common/components/NoData';

import './SFCErrorHandlePage.less';

export interface ISFCErrorHandlePageProps {}
type Props = RouteComponentProps<any> & ISFCErrorHandlePageProps;

export function SFCErrorHandlePage(props: Props) {
  return (
    <div className="common-presenter k-common-error-handle-page">
      <div className="error-info">
        <NoData msg={'你访问的内容已被删除或不存在'} show={true} />
      </div>
    </div>
  );
}

export default SFCErrorHandlePage;
